module.exports = __webpack_public_path__ + "img/13.8cf0f117.gif";